import Vue from 'vue'
import VueRouter from 'vue-router'
// import DoctorIn from '../views/DoctorIn.vue'
import DoctorOut from '../views/DoctorOut.vue'
import SignIn from '../views/SignIn.vue'
import WorkSpace from '../views/WorkSpace.vue'
import Chart from '../views/Chart.vue'
import ResetPassword from '../views/ResetPassword.vue'
import Keys from '../views/Keys.vue'
import Organization from '../views/Organization'
import Users from '../views/Users.vue'
import IDFindReport from '../views/IDFindReport.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/work',
    component: WorkSpace,
    children: [
      {
        // 当 /user/:id/profile 匹配成功，
        // UserProfile 会被渲染在 User 的 <router-view> 中
        path: '/work',
        component: DoctorOut
      },
      {
        path: '/work/keys',
        name: 'keys',
        component: Keys
      },
      {
        path: '/work/users',
        name: 'users',
        component: Users
      },
      {
        path: '/work/organization',
        name: 'organization',
        component: Organization
      },
      {
        path: '/work/doctor_out',
        name: 'doctor_out',
        component: DoctorOut
      },
      {
        path: '/work/chart',
        name: 'chart',
        component: Chart
      },
      {
        path: '/work/resetpassword',
        name: 'resetpassword',
        component: ResetPassword
      }
    ],
    beforeEnter: (to, from, next) => {
      var account = global.defaultStore.state.account
      if (account && account.token && account.tokenExpiredAt > new Date()) {
        global.defaultStore.httpDispatch()('signinByToken').then(res => {
          const { code, data } = res.data
          if (code !== 0) {
            localStorage.clear('token')
            localStorage.clear('tokenExpiredAt')
            global.defaultStore.commit('SIGNOUT')
            next('/')
          } else {
            global.defaultStore.commit('USER_RESTORE', data.user)
            next()
          }
        }).catch(() => {
          localStorage.clear('token')
          localStorage.clear('tokenExpiredAt')
          global.defaultStore.commit('SIGNOUT')
          next('/')
        })
      } else {
        next('/')
      }
    }
  },
  {
    path: '/',
    name: 'SignIn',
    component: SignIn
  },
  {
    path: '/88id',
    name: 'IDFindReport',
    component: IDFindReport
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
